// pages/ResetPassword/ResetPassword.tsx
import React from 'react';
import { ArrowLeft, Mail } from 'lucide-react';
import { Link } from '@tanstack/react-router';
import { Button } from 'shared-portal-components-v2';

import { useResetPasswordEmailSent } from '@/hooks/auth/useResetPasswordEmailSent';

export default function ResetPassword() {
  const { state, handlers } = useResetPasswordEmailSent();

  return (
    <div className="w-full">
      <div className="text-center">
        <div className="flex items-center justify-center mb-4">
          <div className="bg-accent/10 p-3 rounded-full">
            <Mail className="w-8 h-8 text-accent" aria-hidden="true" />
          </div>
        </div>

        <h1 className="text-3xl font-bold text-foreground">Check your email</h1>
        <p className="mt-2 text-muted-foreground text-lg">
          We've sent a recovery code to your email. Enter the code on the next screen to
          verify your identity.
        </p>
      </div>

      <div className="mt-8 flex flex-col gap-4">
        <Button
          type="button"
          variant="primary"
          size="lg"
          className="w-full h-12 text-base font-semibold"
          onClick={() => {
            void handlers.proceed();
          }}
          isLoading={state.isLoading}
        >
          Proceed
        </Button>

        <div className="flex justify-between text-sm">
          <Link
            to="/login"
            className="inline-flex items-center gap-1 text-muted-foreground hover:text-foreground"
          >
            <ArrowLeft className="w-4 h-4" aria-hidden="true" />
            Back to sign in
          </Link>

          <Button
            type="button"
            variant="link"
            className="p-0 h-auto text-accent hover:text-accent/80"
            onClick={() => {
              void handlers.resend();
            }}
            disabled={state.isLoading}
          >
            Didn't receive the email? Resend
          </Button>
        </div>
      </div>
    </div>
  );
}
